import styled from 'styled-components';

export const ModalMessage = styled.div`
  text-align: center;
  padding: 0 12px;
  font-size: 15px;
  letter-spacing: 0px;
  line-height: 20px;
  width: -webkit-fill-available;
  width: -moz-available;
  & > div {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;
